"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.LETTER_SPACING = exports.CONFIG = exports.SIZES = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var media_1 = require("../../../theme/media");
var theme_1 = require("../../../theme");
exports.SIZES = {
    1: {
        fontSize: '16px',
        lineHeight: '175%',
    },
    2: {
        fontSize: '14px',
        lineHeight: '175%',
    },
    3: {
        fontSize: '12px',
        lineHeight: '175%',
    },
};
exports.CONFIG = {
    '1': {
        large: exports.SIZES[1],
        medium: exports.SIZES[2],
        small: exports.SIZES[3],
    },
    '2': {
        large: exports.SIZES[2],
        medium: exports.SIZES[3],
        small: exports.SIZES[3],
    },
    '3': {
        large: exports.SIZES[3],
        medium: exports.SIZES[3],
        small: exports.SIZES[3],
    },
};
exports.LETTER_SPACING = '0.09em';
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'Px', Helvetica, Arial, sans-serif;\n  font-weight: bold;\n  letter-spacing: ", ";\n  text-transform: uppercase;\n  color: ", ";\n\n  font-size: ", ";\n  line-height: ", ";\n\n  @media ", " {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  @media ", " {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"], ["\n  font-family: 'Px', Helvetica, Arial, sans-serif;\n  font-weight: bold;\n  letter-spacing: ", ";\n  text-transform: uppercase;\n  color: ", ";\n\n  font-size: ", ";\n  line-height: ", ";\n\n  @media ", " {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  @media ", " {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"])), exports.LETTER_SPACING, function (_a) {
    var $color = _a.$color;
    return ($color ? theme_1.theme.colors[$color] : 'currentColor');
}, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].small.fontSize;
}, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].small.lineHeight;
}, media_1.breakpoints.medium, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].medium.fontSize;
}, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].medium.lineHeight;
}, media_1.breakpoints.large, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].large.fontSize;
}, function (_a) {
    var _b = _a.$level, $level = _b === void 0 ? '1' : _b;
    return exports.CONFIG[$level].large.lineHeight;
});
var templateObject_1;
